export const switchLanguage = ({ commit }, lang) => {
	commit('switchLanguage', lang)
}

export const setRawMenuData = ({ commit }, obj) => {
  commit('setRawMenuData', obj)
}

export const addTab = ({ commit }, obj) => {
	commit('addTab', obj)
}

export const delTab = ({ commit }, obj) => {
	commit('delTab', obj)
}

export const delAllTab = ({ commit }) => {
	commit('delAllTab')
}

export const delOtherTab = ({ commit }, obj) => {
	commit('delOtherTab', obj)
}

export const changeActiveTabKey = ({ commit }, val) => {
	commit('changeActiveTabKey', val)
}

export const changeDrawerInfo = ({ commit }, obj) => {
	commit('changeDrawerInfo', obj)
}

export const changeUserInfo = ({ commit }, obj) => {
	commit('changeUserInfo', obj)
}

export const changeDialogInfo = ({ commit }, obj) => {
	commit('changeDialogInfo', obj)
}

export const changeFloatBarMenu = ({ commit }, obj) => {
	if (Array.isArray(obj)) {
		commit('changeFloatBarMenu', obj)
	} else {
		commit('changeFloatBarMenu', [])
	}
}
export const setMenuList = ({ commit }, array) => {
	commit("setMenuList",array)
}
export const setOtherSystemConfig = ({ commit }, obj) => {
	commit("setOtherSystemConfig", obj)
}
export const setCallRecords = ({ commit }, array) => {
	commit("setCallRecords", array)
}
export const setQidianExpand = ({ commit }, val) => {
	commit("setQidianExpand", val)
}
export const setQidianExpandCalling = ({ commit }, val) => {
	commit("setQidianExpandCalling", val)
}
export const setTodayCallCustomers = ({ commit }, obj) => {
	commit("setTodayCallCustomers", obj)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js